import { isValid, format } from 'date-fns';

export const formatIfValid = (date, toFormat) => {
  if (date) {
    if (isValid(new Date(date))) {
      return format(new Date(date), toFormat);
    }
  }
};
